export const SEARCH_PARAMS = {
  code: "code",
  tab: "tab",
  widgetId: "widgetId",
  currentChatId: "currentChatId",
};
